<template>
	<div class="main">
		<el-form :model="queryParams" ref="queryForm" :inline="true" class="demo-form-inline">
			<el-form-item size="small" prop="Status">
				<el-select v-model="queryParams.Status" placeholder="支付状态">
					<el-option label="全部" value=" " />
					<el-option label="待支付" value="0" />
					<el-option label="已投保" value="1" />
					<el-option label="已取消" value="-1" />
					<el-option label="投保失败" value="-2" />
					<el-option label="已退款" value="-4" />
				</el-select>
			</el-form-item>

			<el-form-item size="small" prop="orderNo">
				<el-input v-model="queryParams.orderNo" placeholder="投保单号" />
			</el-form-item>

			<el-form-item size="small" prop="cName">
				<el-input v-model="queryParams.cName" placeholder="投保人姓名" />
			</el-form-item>


			<el-form-item size="small">
				<el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
				<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
			</el-form-item>
		</el-form>

		<div class="list" v-for="(item,index) in orderList" :key="index" v-loading="loading">
			<div class="list_title">
				<div class="" style="font-weight: 600; width: 52%;">
					投保单号：{{item.TradeNo}} {{item.ProductName}}
				</div>
				<div class="" style="">
					<!-- <i class="el-icon-s-promotion" style="color: #e7e7e7;"></i> -->
					<el-image src="https://file.aavisa.com/browser-upload-file/f6a35111-f46c-41eb-b951-3130a9eff8c5.jpg"
						fil="fill" style="width: 0.875rem;height: 0.875rem;"
						v-if="item.Status == -1 || item.Status == 0 || item.Status == -2 || item.Status == -4">
					</el-image>
					<el-image src="https://file.aavisa.com/browser-upload-file/483675ae-d97d-4c21-85aa-9fc4a2ec1dd7.jpg"
						fil="fill" style="width: 0.875rem;height: 0.875rem;" v-else></el-image>
					<span v-if="item.Status == 0" style="color: #999;">未投保</span>
					<span v-if="item.Status == 1" style="color: #000;">已投保</span>
					<span v-if="item.Status == -1" style="color: #999;">已取消</span>
					<span v-if="item.Status == -2" style="color: #999;">投保失败</span>
					<span v-if="item.Status == -2" style="color: #999;margin-left: 0.25rem;">失败原因：{{item.BYNote}}</span>
					<span v-if="item.Status == -4" style="color: #999;">已退款</span>

					<el-button plain type="info" v-if="item.Status == 0" @click="DelInsuranceOrder($event,item.Id)">取消订单
					</el-button>

					<el-button plain type="primary" v-if="item.Status == 0" @click="pay($event,item)">立即支付</el-button>

					<el-button plain type="info" v-if="item.Status == -1 || item.Status == -4"
						@click="DelInsuranceOrder($event,item.Id)">删除订单</el-button>

					<el-button plain type="primary" :loading="downLog" v-if="item.Status == 1"
						@click="down($event,item.BYFile,item.Id,item.CName)">
						下载保单
					</el-button>
					<el-button type="primary" v-if="item.Status == 1"
						@click="goLink('/InsuranceDetail?order=' + item.Id)">查看订单</el-button>

				</div>
			</div>

			<div class="list_info">
				<p style="margin-right: 5.875rem;">{{item.CName}}</p>
				<p>{{sub(item.CardNo)}}</p>
			</div>
			<div class="list_time">
				<div class="" style="display: flex;">
					<div id="">
						支付时间<span style="margin-left: 0.625rem;color: #666;">{{item.PayTime || '未支付'}}</span>
					</div>
					<div id="" style="margin-left: 2.75rem;"
						v-if="item.PayTime && (item.Status == 1 || item.Status == -2 || item.Status == -4)">
						支付金额<span style="margin-left: 0.625rem;color: #666;">￥{{item.Price}}</span>
					</div>
				</div>
				<div class="">
					保障期限 {{item.StartTime}} 至 {{item.EndTime}}
				</div>
			</div>
		</div>

		<div class="" v-if="orderList.length == 0">
			<el-empty description="暂无数据"></el-empty>
		</div>

		<paydialog :paytype="2" :paytypeVisible="paytypeVisible" :cashAmount="cashAmount" :orderId="orderId"
			@onClosed="payClosed">

		</paydialog>
	</div>
</template>

<script>
	import paydialog from '../paydialog/paydialog.vue'
	import axios from 'axios';
	const util = require('../../util.js')
	export default {
		components: {
			paydialog,
		},
		name: 'InsuranceOrder',

		data() {
			return {
				paytypeVisible: false,
				queryParams: {
					Status: '',
					orderNo: '',
					cName: '',
				},
				statusList: ['待支付', '待出单', '已出单', '已取消', '投保失败'],
				orderList: [],
				cashAmount: 0,
				orderId: '',
				loading: false,
				downLog: false
			}
		},
		created() {
			this.getList()
		},

		computed: {
			sub() {
				return (value) => {
					return util._sub_(value, 3, 4)
				}
			}
		},
		methods: {
			goLink(url) {
				console.log(url)
				this.$router.push(url)
			},

			DelInsuranceOrder(e, id) {
				this.$confirm('此操作将永久删除该订单, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.DelInsuranceOrder({
						orderId: id
					}).then(res => {
						let {
							message
						} = res.data
						this.$message({
							type: 'success',
							message: message
						});
						this.getList()
					}).catch(err => {
						this.$message({
							type: 'info',
							message: '删除失败'
						});
						this.getList()
					})

				}).catch((err) => {
					this.$message({
						type: 'info',
						message: err
					});
					this.getList()
				});

			},

			down(e, pdf = false, Id, name) {
				if (this.downLog) return false
				if (pdf) {
					// window.open(
					// 	pdf
					// )
					axios(pdf, { //pdf的位置
						responseType: 'blob', //重要代码
					}).then(res => {
						const url = window.URL.createObjectURL(new Blob([res.data]));
						const link = document.createElement('a');
						link.href = url;
						let fileName = name + "的保单.pdf" //保存到本地的文件名称
						link.setAttribute('download', fileName);
						document.body.appendChild(link);
						link.click();
						console.log(link);
						link.remove();
					})
				} else {
					this.$message.warning('下载中');
					this.downLog = true
					this.$api.InsuranceDownload({
						Id
					}).then(res => {
						if (res.data.status == 200) {
							this.$message.success(res.data.data)
							// window.open(
							// 	'https://www.aavisa.com:443/' + res.data.message
							// )
							axios('https://www.aavisa.com:443/' + res.data.message, { //pdf的位置
								responseType: 'blob', //重要代码
							}).then(res => {
								const url = window.URL.createObjectURL(new Blob([res.data]));
								const link = document.createElement('a');
								link.href = url;
								let fileName = name + "的保单.pdf" //保存到本地的文件名称
								link.setAttribute('download', fileName);
								document.body.appendChild(link);
								link.click();
								console.log(link);
								link.remove();
							})



							this.getList()
						} else {
							this.$message.error(res.data.message)
						}

						this.downLog = false
						console.log(res)
					}).catch(err => {
						this.$message.error('下载失败')
						this.downLog = true
					})
				}

			},

			getEndTime(time) {
				var date = new Date(time);
				var YY = date.getFullYear();
				var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
				var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
				return `${YY}年${MM}月${DD}日`;
			},

			getPayTime(time) {
				var date = new Date(time);
				var YY = date.getFullYear();
				var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
				var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
				return `${YY}-${MM}-${DD}`;
			},

			pay(e, row) {
				this.cashAmount = row.Price;
				this.orderId = row.Id;
				this.paytypeVisible = true;
			},

			payClosed() {
				setTimeout(() => {
					this.cashAmount = 0;
					this.orderId = '';
					this.paytypeVisible = false;
					this.getList();
				}, 1500)
			},

			handleQuery() {
				this.getList()
			},

			resetQuery() {
				this.queryParams = {
					Status: '',
					cName: '',
					orderNo: '',
				}
			},

			getList() {
				let {
					Status,
					cName,
					orderNo
				} = this.queryParams
				this.loading = true
				this.$api.GetInsuranceOrderList({
					pageIndex: 1,
					pageSize: 100,
					Status,
					cName,
					orderNo,
				}).then(res => {
					let {
						data,
						status
					} = res.data;
					if (status == 200) {
						let arr = data;
						for (let x = 0; x < arr.length; x++) {
							arr[x].StartTime = this.getEndTime(arr[x].StartTime.split(" ")[0])
							arr[x].EndTime = this.getEndTime(arr[x].EndTime.split(" ")[0])
							arr[x].PayTime = arr[x].PayTime ? this.getPayTime(arr[x].PayTime.split(" ")[0]) + ' ' +
								arr[x].PayTime.split(" ")[1] : null
						}
						console.log(arr)
						this.orderList = arr
					} else {
						this.$message.warning(res.data.message)
						this.orderList = []
					}
					this.loading = false
				}).catch(err => {
					console.log(err)
					this.$message.warning('查无数据')
					this.orderList = []
					this.loading = false
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	.main {
		width: 100%;
		padding: 1.25rem 0 0 0;
	}

	.list {
		background-color: #fff;
		border: 1px solid #eee;
		margin-bottom: 2rem;
		.list_title {
			height: 3.8125rem;
			border-bottom: 1px solid #eeeeee;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 1.25rem;

			.el-icon-s-promotion {
				margin-right: 0.3125rem;
			}

			/deep/.el-button {
				margin-left: 1.25rem !important;
			}
		}

		.list_info {
			height: 6.5625rem;
			display: flex;
			align-items: center;
			padding-left: 3.25rem;
		}

		.list_time {
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 1px solid #f5f5f5;
			color: #999;
			padding: 0 1.25rem 0.9375rem;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/orderlist/InsuranceOrder.vue